import { useBreakpointValue } from '@skin-seoul/design-system';
import type { SelectOption } from './MobileMultipleSelect';
import { MobileMultipleSelect } from './MobileMultipleSelect';
import { DesktopMultipleSelect } from './DesktopMultipleSelect';

interface SelectProps {
  options: SelectOption[];
  values: string[];
  onChange: (value: string[]) => void;
  title?: string;
  width?: string | number;
}

export const MultipleSelect = (props: SelectProps) => {
  const isMobile = useBreakpointValue({ base: true, tablet: false });

  return isMobile ? <MobileMultipleSelect {...props} /> : <DesktopMultipleSelect {...props} />;
};

export type { SelectOption };
